import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-community'
import { intl } from '../../../../i18n'
import { AggregateField } from '../../../../domain/entity/WbsItemEntity'
import { TimeGrain } from '../../../../lib/functions/report'
import OldDateVO from '../../../../vo/DateVO'
import { DateV2, dateV2Service } from '../../../../domain/value-object/DateV2'
import {
  ContextMenuItemId,
  getMenuIconHtml,
} from '../../../containers/commons/AgGrid/lib/contextMenu'
import { SearchConditionProgress } from '../../../containers/ReportContainer/ReportComponent/SearchCondition/WbsProgressLog'
import { openProgressChart } from '../../ProgressChart'
import { SprintReportRow } from '../model/sprintReportRow'
import { SprintReportSearchCondition } from '../hooks/searchCondition'
import { summarizeValues } from '../lib/reportValueSummarizer'

const TOTAL_COLUMN_KEY = 'total'

const getColumnDateRange = (
  field: string,
  searchCondition: SprintReportSearchCondition
): { from: Date; to: Date } => {
  // ProgressChart は半開区間で集計するので終端を1日加算して合わせる
  if (field === TOTAL_COLUMN_KEY) {
    const from = dateV2Service.fromNumber(searchCondition.dateTerm.startDate)
    const endBase = dateV2Service.fromNumber(searchCondition.dateTerm.endDate)
    return {
      from: from ?? new Date(NaN),
      to: endBase ? dateV2Service.addDays(endBase, 1) : new Date(NaN),
    }
  }
  // 日付カラムは field がそのカラムの開始日（YYYY-MM-DD）になっている
  const columnStart = dateV2Service.fromString(field)
  if (!columnStart) {
    return { from: new Date(NaN), to: new Date(NaN) }
  }
  return {
    from: columnStart,
    to: addByGrain(columnStart, searchCondition.timeGrain),
  }
}

const addByGrain = (date: DateV2, grain: TimeGrain): DateV2 => {
  switch (grain) {
    case TimeGrain.DAY:
      return dateV2Service.addDays(date, 1)
    case TimeGrain.WEEK:
      return dateV2Service.addDays(date, 7)
    case TimeGrain.TWO_WEEKS:
      return dateV2Service.addDays(date, 14)
    case TimeGrain.MONTH:
      return dateV2Service.addMonths(date, 1)
    default:
      return dateV2Service.addDays(date, 7)
  }
}

export const createSprintReportContextMenuItems = (
  params: GetContextMenuItemsParams<SprintReportRow>,
  searchCondition: SprintReportSearchCondition
): MenuItemDef[] => {
  if (!params.node || !params.node.data || !params.column) return []
  const field = params.column.getColDef().field
  if (!field) return []

  const dateRange = getColumnDateRange(field, searchCondition)
  const sum = summarizeValues(
    params.node.data.values,
    dateRange,
    AggregateField.WBS_ITEM_WORKLOAD
  )
  const validCodes = sum.wbsItemCodes.filter(c => !!c)
  const isDisabled = validCodes.length === 0

  return [
    {
      name: intl.formatMessage({ id: 'openProgressReportFlag' }),
      disabled: isDisabled,
      icon: getMenuIconHtml(ContextMenuItemId.DISPLAY_GRAPH),
      tooltip: isDisabled
        ? intl.formatMessage({
            id: 'bulksheet.contextMenu.disabled.display.graph.sprint.report',
          })
        : undefined,
      action: () => {
        const fromMs = dateRange.from.getTime()
        // ProgressChart は閉区間で表示するため、終端を1日戻す
        const toMs = dateV2Service.addDays(dateRange.to, -1).getTime()
        openProgressChart(
          SearchConditionProgress.with({
            time: {
              from: new OldDateVO(fromMs),
              to: new OldDateVO(toMs),
            },
            wbsItemCodes: validCodes.join(','),
          })
        )
      },
    },
  ]
}
